import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=56dd3167&"
import script from "./CartTotal.vue?vue&type=script&lang=js&"
export * from "./CartTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports